module.exports = __webpack_public_path__ + "static/prabal-dutta-f661252c8a93b175b4a6cc8c87db9c68.jpg";